import { useFormContext } from 'react-hook-form';
import { ExtendFile } from '@/components/file-thumbnail/utils';

/**
 * React Hook Form과 MultiFileUploader를 연동하기 위한 훅
 * 함수형 업데이트를 올바르게 처리하고 밸리데이션을 자동으로 트리거합니다.
 */
export const useRHFFileUpload = (name: string) => {
  const { setValue, getValues } = useFormContext();

  /**
   * 배열 파일 업로드용 setValue 핸들러
   */
  const handleSetValue = (
    files: ExtendFile[] | ((prev: ExtendFile[]) => ExtendFile[]),
  ) => {
    let newValue: ExtendFile[];

    if (typeof files === 'function') {
      // 함수형 업데이트인 경우, getValues로 최신 값 가져오기
      const currentValue = getValues(name);
      newValue = files(currentValue);
    } else {
      newValue = files;
    }

    // setValue로 값 설정 및 밸리데이션 트리거
    setValue(name as any, newValue, { shouldValidate: true });
  };

  /**
   * 단일 파일 업로드용 setValue 핸들러
   * 배열을 단일 객체로 변환하고 'deleted' 상태 필터링
   */
  const handleSetSingleValue = (
    files: ExtendFile[] | ((prev: ExtendFile[]) => ExtendFile[]),
  ) => {
    let finalValue: ExtendFile | null;

    if (typeof files === 'function') {
      // 함수형 업데이트인 경우, getValues로 최신 값 가져오기
      const currentValue = getValues(name as any);
      const prevArray = currentValue ? [currentValue] : [];
      const newFiles = files(prevArray);
      const validFiles = newFiles.filter((f) => f.status !== 'deleted');
      finalValue = validFiles.length > 0 ? validFiles[0] : null;
    } else {
      // 일반 배열인 경우
      const validFiles = files.filter((f) => f.status !== 'deleted');
      finalValue = validFiles.length > 0 ? validFiles[0] : null;
    }

    setValue(name as any, finalValue, { shouldValidate: true });
  };

  return {
    handleSetValue,
    handleSetSingleValue,
  };
};
